// import React from "react";

export const removeAllHightlight = (screenList) => {

  for (let i = 0; i < screenList.length; i++) {
    screenList[i].setHighlight(false);
  }
};
